import "./index.css";
import GdnAdTemplate from "../GdnAdTemplate";

/**
 * Google Display Network — Japan 300×100 (rendered @2× = 600×200).
 * Icon-only logo top-left, title + subtitle below; shared body in
 * ../GdnAdTemplate.
 */
const GdnJapanAds = ({id, zoom}) => <GdnAdTemplate id={id} zoom={zoom} variant="icon" />;

export default GdnJapanAds;
